import { Screen } from 'quasar';

export default () => {
  return {
    /**
     * Show (or hide) main menu
     */
    leftMenuDrawerOpen: Screen.gt.xs,

    /**
     * Show encryption keys dialog
     */
    encryptionKeysDialogOpen: false,

    /**
     * Show decryption keys dialog
     */
    decryptionKeysDialogOpen: false,
  };
};
